import {createElement} from 'highcharts';
import Swiper from 'swiper';

async function buildSlidesFrontend(ids, apiEndpoint, swiperPlaceholder) {
    if (!ids.length) return '';

    const html = [];
    const res = await fetch(`${apiEndpoint}?id=${ids.join(',')}`).catch((err) => console.log(JSON.stringify(err)));

    const json = await res.json();

    json.forEach(({url, metadata}) => {
        html.push(`
            <div class="swiper-slide">
                <div class="card card--profile no-wysiwyg">
                    <a href="${url}">
                        <div class="card__copy-gradient">
                            <div class="card__copy" style="background-image: url('${metadata.profile_photo_url}')">
                                <div class="card__container">
                                    <div class="card__bottom">
                                        <h3 class="card__heading body-size-xl">${metadata.preferred_name} ${metadata.last_name}</h3>
                                    </div>
                                    <div class="card__block">
                                        <div class="card__metadata metadata-wrapper metadata-wrapper--inline">
                                            ${metadata.role_category ? `<div class="body-default">${metadata.role_category}</div>` : metadata.job_code ? `<div class="body-default">${metadata.job_code}</div>` : ''}
                                            ${metadata.location ? `<div class="body-default">${metadata.location}</div>` : ``}
                                        </div>
                                        <div class="card__arrow-link">
                                            <svg aria-hidden="true"><use xlink:href="#arrow-diagonal"></use></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        `);
    });

    const output = html.join('');

    const contentHTML = createElement('div');
    contentHTML.id = 'the-swiper-wrapper';
    contentHTML.className = 'swiper-wrapper';
    contentHTML.innerHTML = output;

    swiperPlaceholder.replaceWith(contentHTML);
}

export async function profileCardsSwiper() {
    const idArrString = document.querySelector('meta[name="contributor"]');
    const ids = idArrString && idArrString.content ? JSON.parse(idArrString.content) : [];
    const swiperPlaceholder = document.getElementById('swiper-placeholder');

    if (ids.length > 0 && swiperPlaceholder) {
        const siteEndpoint = swiperPlaceholder.getAttribute('data-api-endpoint');

        await buildSlidesFrontend(ids, siteEndpoint, swiperPlaceholder);
    }

    initCarousels();
}

function setButtonDisabled(carousel, selector, setDisabled) {
    const buttons = carousel.querySelectorAll(selector);
    if (buttons) {
        buttons.forEach((button) => {
            if (setDisabled) {
                button.setAttribute('disabled', '');
            } else {
                button.removeAttribute('disabled');
            }
        });
    }
}

/**
 * Determine the value for `slidesPerView` for each breakpoint.
 *
 * There are some specific rules for this value depending on
 * how many cards can be displayed at one time and how Swiper.js
 * calculates width and spacing.
 *
 * @param {Integer} totalSlideCount
 * The total number of slides in the slider
 *
 * @param {Integer} breakpointWidth
 * The viewport size to set the slidesPerView value for
 *
 * @returns Number
 */
function getSlidesPerBreakpoint(totalSlideCount, breakpointWidth) {
    let slidesPerView = 1.2;

    switch (breakpointWidth) {
        case 569:
            slidesPerView = 2.3;

            if (totalSlideCount === 2) {
                slidesPerView = 1.5;
            }
            break;

        case 841:
            slidesPerView = 3.3;

            if (totalSlideCount <= 3) {
                slidesPerView = totalSlideCount;
            }
            break;

        case 1200:
            slidesPerView = 2.8;

            if (totalSlideCount === 2) {
                slidesPerView = 2;
            }

            if (totalSlideCount === 3) {
                slidesPerView = 2.5;
            }
            break;

        case 1500:
            slidesPerView = 3.3;

            if (totalSlideCount <= 3) {
                slidesPerView = totalSlideCount;
            }
            break;

        case 1921:
            slidesPerView = 3.8;

            if (totalSlideCount <= 3) {
                slidesPerView = totalSlideCount;
            }

            if (totalSlideCount === 4) {
                slidesPerView = 3.5;
            }
            break;

        case 2560:
            slidesPerView = 3.8;

            if (totalSlideCount <= 3) {
                slidesPerView = totalSlideCount;
            }

            if (totalSlideCount === 4) {
                slidesPerView = 3.5;
            }
            break;

        case 2880:
            slidesPerView = 4.3;

            if (totalSlideCount <= 4) {
                slidesPerView = totalSlideCount;
            }
            break;

        case 3440:
            slidesPerView = 4.5;

            if (totalSlideCount <= 4) {
                slidesPerView = totalSlideCount;
            }
            break;
        default:
            break;
    }

    return slidesPerView;
}

function initCarousels() {
    const carousels = document.querySelectorAll('.profile-cards-carousel');

    // Loop through each carousel and initialize Swiper
    carousels.forEach((carousel) => {
        const carouselWrapper = carousel.querySelector('.swiper.cards-carousel');
        // const isAutoplayEnabled = carousel.classList.contains('autoplay-enabled');
        const isAutoplayEnabled = false;
        const slides = carousel.querySelectorAll('.swiper-slide');
        const slidesCount = slides.length;

        const swiperPrev = carousel.querySelectorAll('.swiper-button-prev');
        const swiperNext = carousel.querySelectorAll('.swiper-button-next');

        const viewportWidth = window.innerWidth;

        function updateButtonColor(selector, color) {
            const buttons = carousel.querySelectorAll(selector);
            if (buttons) {
                buttons.forEach((button) => {
                    button.style.fill = color;
                });
            }
        }

        carousel.setAttribute('data-total-slides', slides.length);
        // Check viewport to change Key Contacts carousel direction on load only
        if (viewportWidth >= 1200) {
            carouselWrapper.setAttribute('dir', 'rtl');
            slides.forEach((slide) => {
                slide.setAttribute('dir', 'ltr');
            });
        } else {
            carouselWrapper.setAttribute('dir', 'ltr');
        }

        if (slidesCount >= 2) {
            const swiper = new Swiper(carouselWrapper, {
                autoplay: isAutoplayEnabled
                    ? {
                          delay: 5000,
                      }
                    : false,
                direction: 'horizontal',
                loop: false,
                a11y: {
                    slideRole: '',
                },
                slidesPerView: getSlidesPerBreakpoint(slidesCount, 0),
                slidesPerGroup: 1,
                spaceBetween: 16,
                breakpoints: {
                    569: {
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 569),
                        spaceBetween: 16,
                        preventInteractionOnTransition: true,
                    },
                    841: {
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 841),
                        spaceBetween: 16,
                    },
                    1200: {
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 1200),
                        spaceBetween: 20,
                    },
                    1500: {
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 1500),
                        spaceBetween: 24,
                    },
                    1921: {
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 1921),
                        spaceBetween: 40,
                    },
                    2560: {
                        // WQXGA / UWFHD / QHD
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 2560),
                        spaceBetween: 40,
                    },
                    2880: {
                        // WQXGA+
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 2880),
                        spaceBetween: 40,
                    },
                    3440: {
                        // UWQHD
                        slidesPerView: getSlidesPerBreakpoint(slidesCount, 3440),
                        spaceBetween: 40,
                    },
                },
                on: {
                    slideChange: function () {
                        const slidesPerView = this.params.slidesPerView;
                        const totalSlides = this.slides.length;

                        console.log(slidesPerView);

                        const isFirstSlide = this.activeIndex === 0 && !this.params.loop;
                        // Showing two cards at a time
                        const isLastSlide = this.activeIndex >= totalSlides - slidesPerView && !this.params.loop;

                        updateButtonColor('.swiper-button-prev svg path', isFirstSlide ? '#b9bdc8' : '#060D32');
                        updateButtonColor('.swiper-button-next svg path', isLastSlide ? '#b9bdc8' : '#060D32');

                        if (isFirstSlide) {
                            setButtonDisabled(carousel, '.swiper-button-prev', true);
                        } else {
                            setButtonDisabled(carousel, '.swiper-button-prev', false);
                        }

                        if (isLastSlide) {
                            setButtonDisabled(carousel, '.swiper-button-next', true);
                        } else {
                            setButtonDisabled(carousel, '.swiper-button-next', false);
                        }
                    },
                    reachEnd: function () {
                        setButtonDisabled(carousel, '.swiper-button-next', true);
                        updateButtonColor('.swiper-button-next svg path', '#b9bdc8');
                    },
                },
            });

            const prevButtonPaths = carousel.querySelectorAll('.swiper-button-prev svg path');
            const color = swiper.realIndex === 0 && !swiper.params.loop ? '#b9bdc8' : '#060D32';

            prevButtonPaths.forEach((path) => {
                path.style.fill = color;
            });

            swiperPrev.forEach((prev) => {
                prev.addEventListener('mousedown', () => {
                    swiper.slidePrev();
                });
                prev.addEventListener('touch', () => {
                    swiper.slidePrev();
                });
                prev.addEventListener('keydown', (e) => {
                    if (e.code == 'Space' || e.code == 'Enter') {
                        e.preventDefault();
                        swiper.slidePrev();
                        // Focus on current slide
                        slides[swiper.activeIndex].querySelector('a').focus();
                    }
                });
            });

            swiperNext.forEach((next) => {
                next.addEventListener('mousedown', () => {
                    swiper.slideNext();
                });
                next.addEventListener('touch', () => {
                    swiper.slideNext();
                });
                next.addEventListener('keydown', (e) => {
                    if (e.code == 'Space' || e.code == 'Enter') {
                        e.preventDefault();
                        swiper.slideNext();
                        // Focus on current slide
                        slides[swiper.activeIndex].querySelector('a').focus();
                    }
                });
            });

            setButtonDisabled(carousel, '.swiper-button-prev', true);
        } else {
            carouselWrapper?.classList.add('orient--right');

            slides.forEach((slide) => {
                slide.classList.add('slide--single');
            });

            swiperPrev.forEach((prev) => {
                prev.style.display = 'none';
            });

            swiperNext.forEach((next) => {
                next.style.display = 'none';
            });
        }
    });
}
